<!--  学习   -->
<template>
  <div class="container">
    <headerNav  :header-title="webName" :show-sort="showSort" @isShow="getStatus" @yinYang="yinYang" />
    <CourseList :class="isNeedCloseIn390 ? 'course_box' : ''" :showNav="showNav"  ref="pageList" :prpo-div-status="prpoDivStatus" :download-show="downloadShow" :msg="msg" :is-not-app="isNotInApp"></CourseList>
    <footerNav active="/lesson_channel"></footerNav>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import CourseList from '@/components/course/Course-list.vue'
import { getLessonListByCate } from '@/api/lesson.js'
import tool from '@/utils/tools.js'

export default {
  components: {
    CourseList
  },
  data() {
    return {
      webName: Cookies.get('webName') || '',
      isNotInApp: true,
      prpoDivStatus: true,
      downloadShow: true,
      msg: Cookies.get('webSpecialty_id') || '',
      lesson_name: '',
      student_num: '',
      comment_rate: '',
      count: 0,
      lessonArr: [],
      maxPages: '',
      isUnMore1: false,
      isLoading1: false,
      page: 1,
      timer: null,
      limit: 10,
      showSort: '0',
      loading: false,
      finished: false,
      Before_scollH: 0,
      showNav:false,
      // 其他机构嵌套他们app的，Eg：390，需要给个关闭按钮,调用他们自己的方法
      isNeedCloseIn390: false
    }
  },
  computed: {

  },
  created() {
    const need = tool.checkLocationAgencyIdInApp('390')
    if(need){
      this.isNeedCloseIn390 = true
    }
    // this.pageInit()
    // this.getlist()
    if(!Cookies.get('webSpecialty_id')){
      this.showSort = '1'
      this.showNav = false
    }else{
      this.showNav = true
    }
  },
  mounted() {
    // 头部下拉隐藏,上拉显示
    // this.$nextTick(() => {
    //   const _this = this
    //   window.onscroll = function() {
    //     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //     if (scrollTop <= 0) { // 处理回弹
    //       _this.downloadShow = true
    //     } else {
    //       const differH = scrollTop - _this.Before_scollH
    //       if (differH == 0) {
    //         _this.downloadShow = true
    //       }
    //       const scollType = differH > 0 ? 'down' : 'up'
    //       _this.Before_scollH = scrollTop
    //       if (scollType == 'down') {
    //         _this.downloadShow = false
    //       } else if (scollType == 'up') {
    //         _this.downloadShow = true
    //       }
    //     }
    //   }
    // })
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  methods: {
    getStatus(val){
      if(val==1){
        this.showNav = false
      }
    },
    getMoreDatas() {
      this.onLoad()
    },
    // beforeOnLoad() {
    //   // 注意顺序
    //   this.lessonArr = []
    //   this.finished = false
    //   this.page = this.getCurrentPage()
    //   this.onLoad()
    // },
    getCurrentPage() {
      const count = this.lessonArr.length
      const limit = this.limit
      const page = Math.ceil((count / limit)) + 1 // 默认1
      return page
    },
    onLoad() {
      this.loading = true
      this.page = this.getCurrentPage()
      console.log('page is ' + this.page)
      const params = {
        type: 1,
        page: this.page,
        pageSize: this.limit,
        category_id: Cookies.get('webSpecialty_id') || '',
        level: 2
      }
      getLessonListByCate(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        this.count = result.count
        if (this.page === 1) {
          this.lessonArr = list
        } else {
          this.lessonArr = this.lessonArr.concat(list)
        }
        // 是否 有值显示
        if (this.lessonArr.length > 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        // 是否结束
        if (list.length < this.page) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
        }
      })
    },
    yinYang(value) {
      this.webName = value.className
      this.webSpecialty_id = value.secondId
      this.webMainId = value.firstId
      this.prpoDivStatus = true
      this.msg = value.secondId + ''
      this.showNav = true
      // this.getlist()
    },
    isShow(val) {
      console.log(val)
      this.prpoDivStatus = false
    },
    // pageInit() {
    //   this.webName = this.$route.query.webName
    //   this.webMainId = this.$route.query.webMainId
    //   this.webSpecialty_id = this.$route.query.webSpecialty_id
    // },
    // getlist() {
    //   const info = {
    //     type: 1,
    //     page: this.page,
    //     limit: this.limit,
    //     category_id: Cookies.get('webSpecialty_id') || '',
    //     level: 2
    //   }
    //   getLessonListByCate(info).then(res => {
    //     this.count = res.result.count
    //     this.maxPages = res.result.count
    //     // if (this.count === 0) {
    //     //   this.$message({
    //     //     message: '暂无数据'
    //     //   })
    //     // } else {
    //     this.lessonArr = res.result.list
    //     // }
    //   })
    // },
    go_course(id) {
      this.$router.push({
        path: '/details/course',
        query: {
          lesson_id: id
        }
      })
    }

  }
}
</script>

<style lang='scss' scoped>
.container{
  overflow: hidden;
}
.course_box{
  margin-top: 80px;
}
.hei{
  height: 200px;
}
.item_lesson{
        display: flex;
        align-items: center;
        padding: 0px 36px;
        height: 195px;
        border-bottom: 1px solid #ececec;
        .l_img{
          width: 240px;
          height: 150px;
          float: left;
          margin-right: 20px;
        }
        .r_msg{
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title{
            font-size: 28px;
            font-weight: bold;
          }
          .cate{
            display: flex;
            align-items: center;
            .r{
              margin-left: 10px;
            }
            .l,.r{
              display: flex;
              align-items: center;
              color: #909090;
              img{
                margin-right: 5px;
              }
            }
          }
        }
      }
</style>
